export class ConsumerLightAppRelationEntity {
    public id?: number
    public userName = ''
    lightAppId = ''
    lightAppSort = ''
    createTime?: Date
    updateTime?: Date
    createBy = ''
    updateBy = ''

}